import React from 'react';
import { Input, Button, Upload } from 'antd';
import { SvgIconText } from 'freesia-ui';
import PropertyGridUtils from '../PropertyGridUtils';
import PropertyEditor from "../PropertyEditor";

export default class OriginalImageEditor extends PropertyEditor {

    state = {
    };

    constructor(props, context) {
        super(props, context);
    }

    onChange(e) {
        this.props.source.value = e.target.value;
        this.setState({ value: this.simplifyValue(e.target.value) });
    }

    onPropertyValueChanged(name, valOld, valNew, subName) {
        this.setState({ value: this.simplifyValue(this.props.source.value) });
    }

    componentWillMount() {
        super.componentWillMount();
        this.setState({ value: this.simplifyValue(this.props.source.value) });
    }

    componentWillReceiveProps(nextProps) {
        super.componentWillReceiveProps(nextProps);
        this.setState({ value: this.simplifyValue(nextProps.source.value) });
    }

    simplifyValue(val) {

        if (!val)
            return null;
        if (val.length <= 1000)
            return val;

        return val.substring(0, 1000) + "...";
    }

    render() {

        return (
            <Input className="image-editor" addonAfter={(
                <Upload customRequest={this.onUpload.bind(this)} showUploadList={false}>
                    <Button className="btn-bd-focus-none btn-pd-sm btn-bk-hover btn-bd-none image-selector" >
                        <SvgIconText type="#anticon-folder5" />
                    </Button>
                </Upload>
            )} value={this.state.value} onChange={e => this.onChange(e)} placeholder={this.props.source.placeholder || ""} />
        );
    }
}

PropertyGridUtils.register("original-image", (source, propertyGrid) => <OriginalImageEditor source={source} propertyGrid={propertyGrid} />);